
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ScheduledPickupItem } from '@/features/schedule-pickup/types';
import { useFormatTimestamp } from '@/features/common/helpers';
import { getDisplayCarrierCode } from '@/features/common/helpers/carrier';

@Component
export default class HistoryItemDetails extends Vue {
  @Prop({ required: false, default: false }) show!: boolean;

  @Prop({ required: false, default: false }) isCancelled!: boolean;

  @Prop({ required: true }) pickup!: ScheduledPickupItem;

  private useFormatTimestamp = useFormatTimestamp;

  get displayCarrierCode(): string {
    return getDisplayCarrierCode(this.pickup.carrierCode, this.pickup.selectedService || '');
  }
}
